import React from 'react'

import { Box, Display, DisplayPosition, Text } from '@gousto-internal/citrus-react'

import type { MenuRecipeGeneralTag, StandardRecipeItem } from '@library/api-menu-experience'

import { DietaryWarningTag } from '../../../Tags'
import { LabelPill } from '../RecipeTile.styles'
import { getRecipeTileGeneralTags } from '../RecipeTile.utils'

type GeneralLabelRowProps = {
  recipe: StandardRecipeItem
  isOutOfStock: boolean
  reserveCtaSpace: boolean
}

export const GeneralLabelRow = ({
  recipe,
  isOutOfStock,
  reserveCtaSpace,
}: GeneralLabelRowProps) => {
  const labels = getRecipeTileGeneralTags(recipe)

  if (!isOutOfStock && labels.length === 0) {
    return null
  }

  const wrapperStyle: React.CSSProperties = {
    position: DisplayPosition.Absolute,
    top: '1rem',
    left: '1rem',
    transform: 'translateY(calc(-50% - 1rem))',
    zIndex: 12,
    minWidth: 0,
    maxWidth: reserveCtaSpace ? 'calc(100% - 88px)' : 'calc(100% - 2rem)',
    overflow: 'hidden',
  }

  if (isOutOfStock) {
    return (
      <Box style={wrapperStyle}>
        <LabelPill
          data-testid="sold-out-tag"
          style={{
            backgroundColor: '#4F5C68',
            color: '#FFFFFF',
          }}
        >
          <Text size={2} style={{ color: 'inherit', lineHeight: '24px' }}>
            Sold Out
          </Text>
        </LabelPill>
      </Box>
    )
  }

  return (
    <Box
      data-testid="recipe-tile-general-labels"
      display={Display.Flex}
      gap={1}
      style={wrapperStyle}
    >
      {labels.map((label) => (
        <GeneralLabel key={`${label.type}-${label.text}`} label={label} />
      ))}
    </Box>
  )
}

const GeneralLabel = ({ label }: { label: MenuRecipeGeneralTag }) => {
  if (label.type === 'invalidPreference') {
    return <DietaryWarningTag text={label.text} />
  }

  return (
    <LabelPill
      style={{
        backgroundColor: label.backgroundColor.light,
        color: label.color.light,
      }}
    >
      <Text
        size={2}
        style={{
          color: 'inherit',
          lineHeight: '24px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {label.text}
      </Text>
    </LabelPill>
  )
}
